import { RootState } from '../store';

export const selectPlan = (state: RootState) => state.subscription.userSubscription?.plan || null;
export const selectPostsUsed = (state: RootState) =>
    state.subscription.userSubscription?.direct_posts_used || 0;
export const selectIsFreeSubscription = (state: RootState) => state.subscription.isFreeSubscription;
export const selectIsBasicSubscription = (state: RootState) =>
    state.subscription.isBasicSubscription;
export const selectIsPremiumSubscription = (state: RootState) =>
    state.subscription.isPremiumSubscription;
export const selectIsProSubscription = (state: RootState) => state.subscription.isProSubscription;
export const selectImageGenerated = (state: RootState) =>
    state.subscription.userSubscription?.image_generations_used || 0;

export const selectProducts = (state: RootState) => state.subscription.products;
export const selectUserSubscription = (state: RootState) => state.subscription.userSubscription;
